import type { DefaultQueryError } from '@ahm/api-wrappers-core';
import { type UseMutationOptions, useMutation } from '@tanstack/react-query';
import {
  type SaveDraftRequestBody,
  createDraftFn,
} from '@/api/order/create-draft-fn';

export const useCreateDraft = (
  opts?: UseMutationOptions<any, DefaultQueryError, SaveDraftRequestBody>
) =>
  useMutation<any, DefaultQueryError, SaveDraftRequestBody>({
    mutationFn: createDraftFn,
    ...opts,
  });
